import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_2 = { class: "mt-4 flex items-center justify-center gap-4" }

import Button from 'primevue/button';

import DefaultInput from '../components/DefaultInput.vue';
import DefaultSelect from '../components/DefaultSelect.vue';
import PostalCode from '../components/PostalCode.vue';

import { useClientForm } from '../composables/useClientForm';

import { PROVINCES } from '../utils/constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerProfileForm',
  setup(__props) {

const { form, errors, isPending, handleAddClient } = useClientForm();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_unref(handleAddClient) && _unref(handleAddClient)(...args)), ["prevent"]))
  }, [
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "mb-4 flex justify-between" }, [
      _createElementVNode("h2", { class: "font-bold text-gray-900" }, "Dane osobowe"),
      _createElementVNode("span", { class: "text-sm text-gray-iron-700" }, "* - pole obowiązkowe")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(DefaultInput, {
        class: "col-span-6",
        modelValue: _unref(form).first_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).first_name) = $event)),
        error: _unref(errors).first_name
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [
          _createTextVNode(" Imię* ")
        ])),
        _: 1
      }, 8, ["modelValue", "error"]),
      _createVNode(DefaultInput, {
        class: "col-span-6",
        modelValue: _unref(form).last_name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).last_name) = $event)),
        error: _unref(errors).last_name
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createTextVNode(" Nazwisko* ")
        ])),
        _: 1
      }, 8, ["modelValue", "error"]),
      _createVNode(DefaultInput, {
        class: "col-span-6",
        modelValue: _unref(form).email,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).email) = $event)),
        error: _unref(errors).email
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [
          _createTextVNode(" E-mail* ")
        ])),
        _: 1
      }, 8, ["modelValue", "error"]),
      _createVNode(DefaultInput, {
        class: "col-span-6",
        modelValue: _unref(form).phone,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).phone) = $event)),
        error: _unref(errors).phone
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [
          _createTextVNode(" Numer telefonu* ")
        ])),
        _: 1
      }, 8, ["modelValue", "error"]),
      _createVNode(DefaultInput, {
        class: "col-span-8",
        modelValue: _unref(form).street,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).street) = $event)),
        error: _unref(errors).street
      }, {
        default: _withCtx(() => _cache[15] || (_cache[15] = [
          _createTextVNode(" Adres* ")
        ])),
        _: 1
      }, 8, ["modelValue", "error"]),
      _createVNode(DefaultInput, {
        class: "col-span-2",
        modelValue: _unref(form).house_number,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).house_number) = $event)),
        error: _unref(errors).house_number
      }, {
        default: _withCtx(() => _cache[16] || (_cache[16] = [
          _createTextVNode(" Numer domu* ")
        ])),
        _: 1
      }, 8, ["modelValue", "error"]),
      _createVNode(DefaultInput, {
        class: "col-span-2",
        modelValue: _unref(form).apartment_number,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).apartment_number) = $event)),
        error: _unref(errors).apartment_number
      }, {
        default: _withCtx(() => _cache[17] || (_cache[17] = [
          _createTextVNode(" Numer mieszkania ")
        ])),
        _: 1
      }, 8, ["modelValue", "error"]),
      _createVNode(DefaultSelect, {
        class: "col-span-2",
        modelValue: _unref(form).province,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).province) = $event)),
        options: _unref(PROVINCES),
        placeholder: "Wybierz",
        filter: "",
        error: _unref(errors).province
      }, {
        default: _withCtx(() => _cache[18] || (_cache[18] = [
          _createTextVNode(" Województwo* ")
        ])),
        _: 1
      }, 8, ["modelValue", "options", "error"]),
      _createVNode(DefaultInput, {
        class: "col-span-8",
        modelValue: _unref(form).city,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).city) = $event)),
        error: _unref(errors).city
      }, {
        default: _withCtx(() => _cache[19] || (_cache[19] = [
          _createTextVNode(" Miejscowość* ")
        ])),
        _: 1
      }, 8, ["modelValue", "error"]),
      _createVNode(PostalCode, {
        class: "col-span-2",
        modelValue: _unref(form).postal_code,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).postal_code) = $event)),
        error: _unref(errors).postal_code
      }, {
        default: _withCtx(() => _cache[20] || (_cache[20] = [
          _createTextVNode(" Kod pocztowy* ")
        ])),
        _: 1
      }, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Button), {
        class: "font-semibold",
        size: "small",
        outlined: "",
        type: "submit",
        disabled: Object.keys(_unref(errors)).length > 0 || _unref(isPending)
      }, {
        default: _withCtx(() => _cache[21] || (_cache[21] = [
          _createTextVNode(" Zapisz zmiany ")
        ])),
        _: 1
      }, 8, ["disabled"]),
      (_ctx.$route.name !== 'NewClientView')
        ? (_openBlock(), _createBlock(_component_RouterLink, {
            key: 0,
            to: `/${_ctx.$route.params.calculatorId}/client/${_ctx.$route.params.clientId}/calculation/new`
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                class: "font-semibold",
                size: "small"
              }, {
                default: _withCtx(() => _cache[22] || (_cache[22] = [
                  _createTextVNode(" Dodaj kalkulacje "),
                  _createElementVNode("i", { class: "pi pi-arrow-right" }, null, -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}
}

})